// extracted by mini-css-extract-plugin
module.exports = {"root":"ios-app-badge_root__NwL6G","link":"ios-app-badge_link__C_lz_","image":"ios-app-badge_image__aHAPY"};